import axios from 'axios'
import { BASE_URL } from '../../constants/urls'
import { api } from './interceptor'

const putApi = (data, token, path) => {
	return api.put(BASE_URL + path, data, {
		headers: {
			'x-auth-token': token,
		},
	})
}

export { putApi }
